export default {
  button: {
    create: 'Create Video'
  },
  tab: {
    dashboard: 'Dashboard',
    videos: 'All Videos',
    learning_path: 'Learning Paths',
    learners: 'Learners',
    learner_group: 'Learner Groups',
    academy: 'Academy'
  }
};
